import { Component, HostListener, OnInit } from '@angular/core';
import { AuthenticationService, BoardService, BoardList } from '../services/index';
import { Subscription } from 'rxjs';
import _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'full-layout',
  templateUrl: './full-layout.component.html'
})

export class FullLayoutComponent implements OnInit {
  public disabled = false;
  public status: {isopen: boolean} = {isopen: false};
  
  displayName:any;
  boardList: BoardList[];
  boardListSubs:Subscription;
  notAllowedDrag = ['/fwdr/list', '/fwdr-owner/list', '/user/list']
  mouseStartEvt: any;
  mouseEndEvt: any;

  @HostListener('window:mousedown', ['$event'])
  public onMousedown(evt: { preventDefault: () => void, stopPropagation: () => void, target: any; }) {
    if (document.getElementsByClassName('sweet-modal-overlay').length) return;
    if (this.notAllowedDrag.includes(this.router.url) && !evt.target.classList.contains('allowedClick')) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  }

  @HostListener('window:mouseup', ['$event'])
  public onMouseup(evt: { preventDefault: () => void, stopPropagation: () => void, target: any; }) {
    if (document.getElementsByClassName('sweet-modal-overlay').length) return;
    if (this.notAllowedDrag.includes(this.router.url) && !evt.target.classList.contains('allowedClick')) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  }

  constructor(private auth:AuthenticationService, private boardService:BoardService, private router: Router) {
    let userInfo:string = localStorage.getItem('currentUser');
    let user:any;
    if (userInfo && userInfo != "undefined" && userInfo != "null") {
      user = JSON.parse(userInfo);
      this.displayName = user.displayName;
    }
  }

  ngAfterViewInit() {
    let links = document.querySelectorAll('.sub-nav') as any;
    links.forEach((link) => {
      link.addEventListener('click', () => {
        document.querySelector('body').classList.remove('sidebar-mobile-show');
      });
    });
  }

  public toggled(open: boolean): void {

  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }
  
  public logOut(){
    this.auth.logout();
  };

  ngOnInit() {
    if(_.isEmpty(this.boardService.boardList)) {
      this.boardService.getBoardListOnInit((boardList) => {
        this.boardList = boardList;
      });
    } else {
      this.boardList = this.boardService.boardList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts